// extracted by mini-css-extract-plugin
export default {"footerContainer":"marketFooter_footerContainer__ncPYT"};